<template>
  <div class="checkbox">
    <label>
      <input type="checkbox"
        :checked="value || checked"
        @input="$emit('input', $event.target.checked)"
        @change="$emit('change', $event.target.checked)">
      <span class="cr">
        <i class="cr-icon glyphicon glyphicon-ok"></i>
      </span>
      <slot name="label"></slot>
    </label>
  </div>
</template>

<script>
  export default {
    props: ['value', 'label', 'checked'],
  };
</script>

<style lang="scss" scoped>
.checkbox {
  label {
    padding-left: 0;
    &:after {
      content: '';
      display: table;
      clear: both;
    }
  }
  .cr {
    position: relative;
    display: inline-block;
    border: 1px solid #a9a9a9;
    border-radius: .25em;
    width: 1.3em;
    height: 1.3em;
    float: left;
    margin-right: .5em;
    .cr-icon {
      position: absolute;
      font-size: .8em;
      line-height: 0;
      top: 50%;
      left: 20%;
    }
  }
  label input[type="checkbox"] {
    display: none;
    + .cr > .cr-icon {
      transform: scale(3) rotateZ(-20deg);
      opacity: 0;
      transition: all .3s ease-in;
    }
    &:checked + .cr > .cr-icon {
      transform: scale(1) rotateZ(0deg);
      opacity: 1;
    }
    &:disabled + .cr {
      opacity: .5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Checkbox.vue?1f80a996